<template>
  <div class="search">
    <div class="search-left">
      <YorkbbsImage
        class="topic-logo"
        width="112px"
        :src="require('@/assets/images/car/logo.png')"
        link="/"
        alt="约克汽车:多伦多汽车信息平台/多伦多二手车和转lease信息平台"
      ></YorkbbsImage>
    </div>
    <div class="search-center">
      <el-input
        class="search-input"
        clearable
        :placeholder="placeholder"
        v-model="keyword"
        @keyup.enter.native="handleSearch"
      >
        <button class="search-button" slot="append" @click="handleSearch">
          <i class="yk-search_forum"></i>
        </button>
      </el-input>
    </div>
    <div class="search-right">
      <div class="search-button__list">
        <el-dropdown class="search-button__item" trigger="hover">
          <el-button type="danger">
            <i class="yk-house_write"></i>
            <span>卖车</span>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <a target="_blank" href="/publish/used">二手车</a>
            </el-dropdown-item>
            <el-dropdown-item>
              <a target="_blank" href="/publish/lease">转Lease</a>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <a class="search-button__item" target="_blank" :href="'/center/information?type=4' | hostBuild('home')">
          <el-button>
            <i class="yk-house_user"></i>
            <span>我的汽车</span>
          </el-button>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Search',
  props: { placeholder: String },
  data() {
    return {
      // 搜索关键词
      keyword: '',
    };
  },
  created() {
    const { keyword } = this.$route.query;
    if (keyword) {
      this.keyword = keyword;
    }
  },
  methods: {
    /**
     * 搜索
     */
    handleSearch() {
      const keyword = this.keyword.trim();
      if (!keyword) return this.$warning('请输入搜索关键词');
      window.open(`/search?keyword=${keyword}`, '_blank');
    },
  },
};
</script>
<style lang="scss" scoped>
.search {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
}
.search-input {
  width: 533px;
  ::v-deep {
    .el-input__inner {
      border-right: 0 none;
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
    }
    .el-input-group__append {
      padding: 0;
      border: 0 none;
      i {
        color: #fff;
      }
    }
  }
  .search-button {
    width: 52px;
    height: 40px;
    background-color: var(--primary-color);
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    &:hover {
      background: #e96161;
      border-color: #e96161;
      color: #fff;
    }
  }
}

.search-button__list {
  display: flex;
}
.search-button__item {
  display: block;
  &:not(:last-child) {
    margin-right: 20px;
  }
  ::v-deep {
    .el-button {
      font-size: 16px;
      i {
        margin-right: 6px;
      }
    }
  }
}

::v-deep {
  .el-dropdown-menu__item {
    width: 128px;
    box-sizing: border-box;
    a {
      display: block;
    }
  }
}
.search-right {
  display: flex;
  align-items: center;
}
</style>
